/* eslint quote-props: ["error", "consistent"] */
const locale = {
  mstSideWeatherName: "Thời tiết",
  mstSideDashboardName: "Bảng khuyến nghị hành động",
  mstSideUserName: "Quản lý người dùng",
  mstSideInsightName: "Thư viện khuyến nghị",
  mstSidePointName: "Địa điểm",
  mstSideHelpName: "Trợ giúp",
  changePassword: "Đổi mật khẩu",
  logout: "Đăng xuất",
  sideWeatherDescription: "Tra cứu thời tiết địa điểm bạn muốn",
  sideDashboardDescription:
    "Đưa ra khuyến nghị hành động dựa trên dự báo thời tiết",
  sideInsightDescription:
    "Sử dụng khuyến nghị của chuyên gia hoặc tự thêm khuyến nghị của riêng bạn",
  changeAccount: "Chỉnh sửa tài khoản",
  mstPackageInfo: "Thông tin gói cước",
  userInfo: "Thông tin tài khoản",
  Welcome: "Chào mừng",
  Phone: "Điện thoại",
  mstSideReport: "Báo cáo",
};

export default locale;
